<template>
  <div class="input-row">
    <img src="../assets//code.png" />
    <input
    type="number"
    placeholder="请输入验证码"
    v-model="value"
    @input="sendValue($event)"
    />
    <div class="line"></div>
    <button
    class="fetch-button"
    :disabled="codeBtnDis"
    @click="handleCode()"
    >{{codeBtnText}}</button>
  </div>
</template>

<script>
import  axios from 'axios'

export default {
  name: 'FetchVerificationCode',
  mixins: [],
  components: {},
  props: {
    phone:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      value:'',
      codeBtnText:'获取验证码',
      codeWait: false // 验证码发送后的60s内不能重复点获取验证码
    }
  },
  computed: {
    codeBtnDis(){
      return this.codeWait || !this.phone
    }
  },
  watch: {},
  created() {
  },
  mounted() {

  },
  destroyed() {
  },
  methods: {
    sendValue(e){
      this.$emit('fetchVerificationCode',e.target.value)
    },

    // 获取验证码
    async handleCode(e) {
      if (this.phone.length !== 11) {
        return window.$toast('请输入正确的手机号')
      }
      const res = await axios.get(
        `https://api.duoke.net/index.php/account/get_captcha?phone=${this.phone}&app_pid=32&app_version=2.65.99`
      )
      if (res.data.err === 0) {
        window.$toast('发送成功')
        this.countDown()
      } else {
        window.$toast(res.data.msg)
      }
    },
    // 倒计时
    countDown() {
      this.codeWait = true
      let count = 60
      this.codeBtnText = '60 S'
      const timer = setInterval(() => {
        count -= 1
        this.codeBtnText = `${count} S`
        if (count <= 0) {
          this.codeBtnText = '获取验证码'
          this.codeWait = false
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;
    height: calc(var(--raito) * 47px);
    background-color: #fff;
    padding: 0 calc(var(--raito) * 14px);
    border-radius: calc(var(--raito) * 5px);
    margin-bottom: calc(var(--raito) * 16px);
    box-sizing: border-box;
    img{
      width: calc(var(--raito) * 15px);
      height: auto;
    }
    input{
      width: auto;
      height: calc(var(--raito) * 19px);
      margin-left: calc(var(--raito) * 10px);
      font-size: calc(var(--raito) * 14px);
      border: none;
      ::placeholder{
        font-family: PingFangSC-Regular;
        color: #CED3E0;
      }
    }
    .line{
      margin-left: auto;
      width: calc(var(--raito) * 1px);
      height: calc(var(--raito) * 19px);
      border-right: 1px solid #F3F3F3;
    }
    .fetch-button{
      display: flex;
      justify-content: center;
      width: calc(var(--raito) * 75px);
      margin-left: calc(var(--raito) * 14px);
      font-family: PingFangSC-Regular;
      font-size: calc(var(--raito) * 14px);
      color: #1DEFA2;
    }
    .fetch-button:active{
      opacity: 0.7;
    }
    .fetch-button:disabled{
      opacity: 0.5;
    }
  }
</style>